import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { revenueStatsProjectionByYear } from "../utils/revenueStatsProjectionByYear"

export const queryAdmRevenueStatsProjection = {
  async admRevenueStatsProjection(parent, args, context, info) {
    const { admNumber, year } = args

    const { user } = context

    await checkPermissions({
      user,
      admNumber: admNumber,
      domainObject: DomainObjects.REVENUES,
      operation: Operations.READ,
    })

    const { projection, monthlyRevenue, yearRevenue } = await revenueStatsProjectionByYear({
      admNumber,
      year,
    })

    return {
      admNumber,
      projection,
      monthlyRevenue,
      yearRevenue,
    }
  },
}
